import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable, takeWhile } from 'rxjs';
import {
  IAdminTokenPayload,
  IAdminUser,
  ICustomerUser,
  Prescription
} from '@care-portals/api-interfaces';
import { getLicenseForProvince } from '@care-portals/shared';
import { PrescriptionFacade } from '../../../+store/prescription/prescription.facade';
import { AuthFacade } from '../../../+store/auth/auth.facade';
import { NzTableModule } from 'ng-zorro-antd/table';
import { CommonModule } from '@angular/common';
import { NzDescriptionsModule } from 'ng-zorro-antd/descriptions';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
@Component({
  selector: 'my-health-admin-prescription-pdf',
  templateUrl: './prescription-pdf.component.html',
  styleUrls: ['./prescription-pdf.component.less'],
  standalone: true,
  imports: [
    CommonModule,
    NzTableModule,
    NzDescriptionsModule,
    NzSpinModule,
    NzButtonModule,
    NzLayoutModule
  ]
})
export class PrescriptionPdfComponent implements OnInit, OnDestroy {
  @Input() rxId: string;
  prescription: Prescription;
  doctor = 'Dr @ Jill Health <doctor@jill.health>';
  replyTo = 'No Reply <no-reply@jill.health';
  toPhamacy = 'pharmacy@jackhealth.ca';
  pharmacyEmail = 'pharmacy@jackhealth.ca';
  user: IAdminTokenPayload;
  loading$: Observable<boolean>;
  signatureUrl: string;

  isActive = false;

  constructor(
    public activatedRoute: ActivatedRoute,
    private facade: PrescriptionFacade,
    private authFacade: AuthFacade
  ) {
    this.isActive = true;
  }

  get isBelugaRx() {
    return (
      this.prescription?.meta?.source === 'beluga' ||
      this.prescription?.meta?.phone === '+12244840496'
    );
  }

  get providerAddress() {
    const rxMeta = this.prescription?.meta ?? {};

    const addressLines = [];

    if (rxMeta.address1) {
      addressLines.push(rxMeta.address1);
    }
    if (rxMeta.address2) {
      addressLines.push(rxMeta.address2);
    }
    if (rxMeta.city) {
      addressLines.push(rxMeta.city);
    }
    if (rxMeta.state) {
      addressLines.push(rxMeta.state);
    }
    if (rxMeta.zip) {
      addressLines.push(rxMeta.zip);
    }

    return addressLines.join(', ');
  }

  get createdBy() {
    return this.prescription?.createdBy as IAdminUser;
  }

  get customer() {
    return this.prescription?.customer as ICustomerUser;
  }

  get matchedLicenseNumber() {
    const province =
      this.customer?.defaultAddress?.provinceCode ||
      this.customer?.defaultAddress?.province;
    return getLicenseForProvince(this.createdBy?.licenses, province)?.number;
  }

  get providerLicenseDisplay() {
    const province =
      this.customer?.defaultAddress?.provinceCode ||
      this.customer?.defaultAddress?.province;
    const license = getLicenseForProvince(this.createdBy?.licenses, province);

    if (license?.number) {
      return license?.label
        ? `${license.label} ${license.number}`
        : `${license.number}`;
    }

    return this.prescription?.meta?.licenseNumber
      ? `${this.prescription.meta.licenseNumber}`
      : '';
  }

  ngOnInit(): void {
    const id = this.rxId || this.activatedRoute.snapshot.params['id'];
    this.facade.selectedPrescription$
      .pipe(takeWhile(() => this.isActive))
      .subscribe(prescription => {
        this.prescription = prescription;
        const userId =
          this.prescription?.createdBy['_id'] || this.prescription?.createdBy;
        this.signatureUrl = `assets/signatures/${userId}.png`;
      });
    this.loading$ = this.facade.loading$;
    this.authFacade.user$
      .pipe(takeWhile(() => this.isActive))
      .subscribe(res => (this.user = res));

    this.facade.fetchPrescription(id);
  }

  ngOnDestroy(): void {
    this.isActive = false;
  }

  downloadPdf(): void {
    const id =
      this.rxId ||
      this.activatedRoute.snapshot.params['id'] ||
      this.prescription?._id;
    if (id) {
      this.facade.downloadPrescriptionPdf(id);
    }
  }
}
